<template>
    <div class="container">
        <div v-if="this.selectedProvider && shouldContinue">
            <component :is="providerComponent" @loading="setLoading" />
        </div>

        <div v-if="error && !shouldContinue" class="error">
            <text-headline-primary>
                {{ texts.error_title }}
            </text-headline-primary>
            <p>{{ texts.error_code }}: {{ error }}</p>
            <text-button @click.prevent="retry">
                {{ texts.retry }}
            </text-button>
        </div>

        <div v-if="!this.selectedProvider && !error" class="providers">
            <text-headline-primary>Vælg betalingsmetode</text-headline-primary>
            <ul>
                <li v-for="p in providers" :key="p">
                    <text-button @click="setPaymentProvider(p)">
                        {{ p }}
                    </text-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import PaymentNetaxept from "@/components/payment/PaymentNetaxept";
import PaymentDeveloper from "@/components/payment/PaymentDeveloper";
import PaymentFree from "@/components/payment/PaymentFree";
import PaymentApplePay from "@/components/payment/PaymentApplePay";
import TextButton from "@/components/elements/TextButton";
import { mapGetters } from "vuex";

export default {
    components: {
        PaymentNetaxept,
        PaymentDeveloper,
        PaymentFree,
        PaymentApplePay,
        TextButton
    },
    computed: {
        texts() {
            return this.$t("page_payment");
        },
        providerComponent() {
            switch (this.selectedProvider) {
                case "Netaxept":
                    return "PaymentNetaxept";
                case "Developer":
                    return "PaymentDeveloper";
                case "Free":
                    return "PaymentFree";
                case "ApplePay":
                    return "PaymentApplePay";
                default:
                    return null;
            }
        },
        realProvider() {
            return process.env.VUE_APP_PAYMENT_PROVIDER;
        },
        providers() {
            const providers = [this.realProvider];
            if (process.env.VUE_APP_SERVER !== "live")
                providers.push("Developer");
            return providers;
        },
        shouldContinue() {
            if (this.selectedProvider) return true;
            if (this.error) return false;
            return true;
        },
        ...mapGetters({
            error: "order/getPaymentProviderError",
            priceOre: "order/getPriceOre",
            selectedProvider: "order/getPaymentProvider"
        })
    },
    mounted() {
        this.evaluateProvider();
        const storage = {
            productType: this.$store.getters["order/getProductType"],
            orderId: this.$store.getters["order/getOrderId"],
            priceOre: this.$store.getters["order/getPriceOre"],
            details: this.$store.getters["order/getDetails"],
            deliveryMethod: this.$store.getters["order/getDeliveryMethod"],
            flowType: this.$store.getters["flow/getType"],
            flowStep: this.$store.getters["flow/getStep"],
            locale: this.$i18n.locale
        };

        this.$cookies.set(
            `order-${storage.orderId}`,
            JSON.stringify(storage),
            "30min"
        );
    },
    methods: {
        evaluateProvider() {
            if (process.env.VUE_APP_SERVER === "live" && this.selectedProvider == null) {
                this.setPaymentProvider(this.realProvider)
            }
        },
        setPaymentProvider(provider) {
            this.$store.commit("order/setPaymentProvider", provider);
        },
        retry() {
            this.setPaymentProvider(this.realProvider);
        },
        setLoading(message) {
            if (!message) {
                this.$emit("loading", false);
            } else {
                this.$emit("loading", true, message);
            }
        }
    }
};
</script>

<style scoped>
.container {
    text-align: center;
}

.providers,
.error {
    margin-top: 4rem;
}

.providers h1 {
    padding: 0 1rem;
}

.providers ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 2rem;
    padding: 0 1rem;
    margin-left: -1rem;
}

.providers li {
    margin-bottom: 1rem;
    margin-left: 1rem;
}
</style>
